import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_EXPERIENCES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_EXPERIENCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_EXPERIENCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_EXPERIENCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_EXPERIENCE:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
